<template>
  <div class="pageArea">
    <Head2></Head2>
    <div class="mainAea">
      <div class="leftArea">
        <div class="leftTitle">{{ $t("pages.guide.left_title") }}</div>
        <ul>
          <li>
            <div class="firstTitle">
              <div>{{ $t("pages.guide.menu.personal_center") }}</div>
            </div>
            <ul class="secondTitle">
              <li
                :class="{ active: type == 'Register' }"
                @click="menuClick('Register')"
              >
                {{ $t("pages.guide.menu.register") }}
              </li>
              <li
                :class="{ active: type == 'Agreement' }"
                @click="menuClick('Agreement')"
              >
                {{ $t("pages.guide.menu.agreement") }}
              </li>
              <li
                :class="{ active: type == 'PrivacyPolicy' }"
                @click="menuClick('PrivacyPolicy')"
              >
                {{ $t("pages.guide.menu.privacy_policy") }}
              </li>
              <li
                :class="{ active: type == 'Forget' }"
                @click="menuClick('Forget')"
              >
                {{ $t("pages.guide.menu.forget") }}
              </li>
            </ul>
          </li>
          <li v-if="currentLanguage === 'zh-CN'">
            <div class="firstTitle">
              <div>{{ $t("pages.guide.menu.new_user_guide") }}</div>
            </div>
            <ul class="secondTitle">
              <li
                :class="{ active: type == 'ToBuy' }"
                @click="menuClick('ToBuy')"
              >
                {{ $t("pages.guide.menu.to_buy") }}
              </li>
              <li
                :class="{ active: type == 'ToPay' }"
                @click="menuClick('ToPay')"
              >
                {{ $t("pages.guide.menu.to_pay") }}
              </li>
              <li
                :class="{ active: type == 'ToSearchOrder' }"
                @click="menuClick('ToSearchOrder')"
              >
                {{ $t("pages.guide.menu.to_search_order") }}
              </li>
            </ul>
          </li>
          <li v-if="currentLanguage === 'zh-CN'">
            <div class="firstTitle">
              <div>{{ $t("pages.guide.menu.delivery_policy") }}</div>
            </div>
            <ul class="secondTitle">
              <li
                :class="{ active: type == 'ShippingFee' }"
                @click="menuClick('ShippingFee')"
              >
                {{ $t("pages.guide.menu.shipping_fee") }}
              </li>
              <li
                :class="{ active: type == 'ShippingInstructions' }"
                @click="menuClick('ShippingInstructions')"
              >
                {{ $t("pages.guide.menu.shipping_instructions") }}
              </li>
            </ul>
          </li>
          <li v-if="currentLanguage === 'zh-CN'">
            <div class="firstTitle">
              <div>{{ $t("pages.guide.menu.after_sales") }}</div>
            </div>
            <ul class="secondTitle">
              <li
                :class="{ active: type == 'SalePolicy' }"
                @click="menuClick('SalePolicy')"
              >
                {{ $t("pages.guide.menu.sale_policy") }}
              </li>
            </ul>
          </li>
          <li v-if="currentLanguage === 'zh-CN'">
            <div class="firstTitle">
              <div>{{ $t("pages.guide.menu.faq") }}</div>
            </div>
            <ul class="secondTitle">
              <li
                :class="{ active: type == 'InvoiceApply' }"
                @click="menuClick('InvoiceApply')"
              >
                {{ $t("pages.guide.menu.invoice_apply") }}
              </li>
              <li
                :class="{ active: type == 'InvoiceSearch' }"
                @click="menuClick('InvoiceSearch')"
              >
                {{ $t("pages.guide.menu.invoice_search") }}
              </li>
            </ul>
          </li>
          <li>
            <div class="firstTitle">
              <div
                :class="{ active: type == 'Platform' }"
                @click="menuClick('Platform')"
              >
                {{ $t("pages.guide.menu.about_us") }}
              </div>
            </div>
            <ul class="secondTitle">
              <li
                :class="{ active: type == 'Platform' }"
                @click="menuClick('Platform')"
              >
                {{ $t("pages.guide.menu.platform") }}
              </li>
              <li
                :class="{ active: type == 'Contact' }"
                @click="menuClick('Contact')"
              >
                {{ $t("pages.guide.menu.contact") }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="rightAre" v-if="type == 'Register'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.register_title") }}
        </div>
        <div class="infoText" v-html="$t('pages.guide.register_content')"></div>
      </div>
      <div class="rightAre" v-if="type == 'Agreement'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.agreement_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.agreement_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'PrivacyPolicy'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.privacy_policy_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.privacy_policy_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'Forget'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.forget_title") }}
        </div>
        <div class="infoText" v-html="$t('pages.guide.forget_content')"></div>
      </div>
      <div class="rightAre" v-if="type == 'ToBuy'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.to_buy_title") }}
        </div>
        <div class="infoText" v-html="$t('pages.guide.to_buy_content')"></div>
      </div>
      <div class="rightAre" v-if="type == 'ToPay'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.to_pay_title") }}
        </div>
        <div class="infoText" v-html="$t('pages.guide.to_pay_content')"></div>
      </div>
      <div class="rightAre" v-if="type == 'ToSearchOrder'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.to_search_order_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.to_search_order_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'ShippingFee'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.shipping_fee_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.shipping_fee_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'ShippingInstructions'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.shipping_instructions_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.shipping_instructions_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'SalePolicy'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.sale_policy_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.sale_policy_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'InvoiceApply'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.invoice_apply_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.invoice_apply_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'InvoiceSearch'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.invoice_search_title") }}
        </div>
        <div
          class="infoText"
          v-html="$t('pages.guide.invoice_search_content')"
        ></div>
      </div>
      <div class="rightAre" v-if="type == 'About'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.platform_title") }}
        </div>
        <div class="infoText" v-html="$t('pages.guide.platform_content')"></div>
      </div>
      <div class="rightAre" v-if="type == 'Platform'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.platform_title") }}
        </div>
        <div class="infoText" v-html="$t('pages.guide.platform_content')"></div>
      </div>
      <div class="rightAre" v-if="type == 'Contact'">
        <div class="title">
          <div class="titleLine"></div>
          {{ $t("pages.guide.contact_title") }}
        </div>
        <div class="infoText" v-html="$t('pages.guide.contact_content')"></div>
      </div>
    </div>
    <Foot2></Foot2>
  </div>
</template>

<script>
import Head2 from "../components/head2.vue";
import Foot2 from "../components/foot2.vue";

export default {
  components: {
    Head2,
    Foot2,
  },
  data() {
    return {
      type: "Platform",
	  currentLanguage: localStorage.getItem("locale-lang") || "zh-CN",
    };
  },
  created() {
    this.type =
      this.$route.query.type != undefined ? this.$route.query.type : this.type;
  },
  methods: {
    menuClick(v) {
      this.type = v;
    },
  },
};
</script>

<style scoped>
.pageArea {
  background-color: #ebecee;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mainAea {
  width: 1200px;
  margin-top: 16px;
  margin-bottom: 17px;
  display: flex;
}

.leftArea {
  width: 233px;
  background-color: #fff;
  padding-bottom: 15px;
  margin-right: 15px;
}

.leftTitle {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  font-size: 17px;
  text-align: center;
  margin-bottom: 15px;
}

ul li {
  list-style: none;
}

.firstTitle {
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  justify-content: center;
  font-weight: bolder;
}

.firstTitle + ul li {
  height: 30px;
  display: flex;
  align-items: center;
  height: 40px;
  justify-content: center;
  font-size: 14px;
  color: #686868;
  cursor: pointer;
}

.firstTitle + ul li:hover,
.firstTitle + ul li.active {
  color: #0380fe;
}

.rightAre {
  width: 958px;
  background: #fff;
}

.title {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  height: 52px;
  border-bottom: 1px solid #e2e2e2;
  padding-left: 20px;
  background-color: #fff;
  background-color: #fff;
}

.titleLine {
  width: 4px;
  height: 14px;
  background-color: #0380fe;
  margin-right: 15px;
}

.infoText {
  font-size: 14px;
  color: #000000;
  line-height: 35px;
  margin: 20px 28px;
}

.imgs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
}

.imgs img {
  margin-bottom: 20px;
}

.agreement-content {
  max-height: 500px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 2;
  color: #222;
}
.agreement-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
}
.agreement-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 18px 0 8px 0;
}
.agreement-content ul {
  padding-left: 20px;
  margin-bottom: 12px;
}
.agreement-content li {
  margin-bottom: 6px;
}

.privacy-content {
  max-height: 500px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 2;
  color: #222;
}
.privacy-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
}
.privacy-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 18px 0 8px 0;
}
.privacy-content ul {
  padding-left: 20px;
  margin-bottom: 12px;
}
.privacy-content li {
  margin-bottom: 6px;
}

.register-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.register-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.register-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
  display: flex;
  align-items: center;
}
.step-number {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: #0380fe;
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  margin-right: 8px;
}
.register-step {
  background: white;
  padding: 20px;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.register-steps {
  padding-left: 20px;
  margin: 12px 0;
}
.register-steps li {
  margin-bottom: 8px;
  line-height: 1.6;
}
.step-image {
  text-align: center;
  margin: 16px 0;
}
.step-image img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.register-tips {
  background: #e8f4fd;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  border-left: 4px solid #0380fe;
}
.register-tips h4 {
  color: #0380fe;
  margin-bottom: 12px;
}
.register-tips ul {
  padding-left: 20px;
}
.register-tips li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.forget-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.forget-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.forget-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
  display: flex;
  align-items: center;
}
.forget-steps {
  padding-left: 20px;
  margin: 12px 0;
}
.forget-steps li {
  margin-bottom: 8px;
  line-height: 1.6;
}
.forget-step {
  background: white;
  padding: 20px;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.forget-step .step-number {
  background: #0380fe;
}

.order-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.order-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.order-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
  display: flex;
  align-items: center;
}
.order-steps {
  padding-left: 20px;
  margin: 12px 0;
}
.order-steps li {
  margin-bottom: 8px;
  line-height: 1.6;
}
.order-step {
  background: white;
  padding: 20px;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.order-step .step-number {
  background: #0380fe;
}
.step-images {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin: 16px 0;
}
.step-images img {
  max-width: 300px;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.order-tips {
  background: #e8f4fd;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  border-left: 4px solid #0380fe;
}
.order-tips h4 {
  color: #0380fe;
  margin-bottom: 12px;
}
.order-tips ul {
  padding-left: 20px;
}
.order-tips li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.payment-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.payment-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.payment-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
  display: flex;
  align-items: center;
}
.payment-step {
  background: white;
  padding: 20px;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.payment-step .step-number {
  background: #0380fe;
}
.payment-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
}
.payment-method {
  flex: 1;
  min-width: 200px;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}
.payment-method:hover {
  border-color: #0380fe;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.2);
}
.method-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.method-info h5 {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 4px 0;
  color: #333;
}
.method-info p {
  font-size: 12px;
  margin: 0;
  color: #666;
  line-height: 1.4;
}
.payment-tips {
  background: #e8f4fd;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  border-left: 4px solid #0380fe;
}
.payment-tips h4 {
  color: #0380fe;
  margin-bottom: 12px;
}
.payment-tips ul {
  padding-left: 20px;
}
.payment-tips li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.order-progress-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.order-progress-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.order-progress-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
  display: flex;
  align-items: center;
}
.progress-step {
  background: white;
  padding: 20px;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.progress-step .step-number {
  background: #0380fe;
}
.progress-info {
  margin: 16px 0;
}
.status-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
}
.status-card {
  flex: 1;
  min-width: 200px;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}
.status-card:hover {
  border-color: #0380fe;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.2);
}
.status-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.status-info h5 {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 4px 0;
  color: #333;
}
.status-info p {
  font-size: 12px;
  margin: 0;
  color: #666;
  line-height: 1.4;
}
.progress-tips {
  background: #e8f4fd;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  border-left: 4px solid #0380fe;
}
.progress-tips h4 {
  color: #0380fe;
  margin-bottom: 12px;
}
.progress-tips ul {
  padding-left: 20px;
}
.progress-tips li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.shipping-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.shipping-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.shipping-section {
  margin-bottom: 24px;
}
.shipping-notice {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.shipping-notice p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.return-shipping {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}
.return-item {
  flex: 1;
  min-width: 200px;
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}
.return-item:hover {
  border-color: #0380fe;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.2);
}
.return-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.return-info h5 {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 4px 0;
  color: #333;
}
.return-info p {
  font-size: 12px;
  margin: 0;
  color: #666;
  line-height: 1.4;
}
.policy-link {
  font-size: 14px;
  color: #0380fe;
  margin-top: 16px;
}
.delivery-info {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}
.delivery-item {
  flex: 1;
  min-width: 200px;
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease;
}
.delivery-item:hover {
  border-color: #0380fe;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.2);
}
.delivery-item h5 {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  color: #333;
}
.delivery-item ul {
  list-style: none;
  padding-left: 0;
}
.delivery-item ul li {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
.delivery-method {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.delivery-method h5 {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 12px 0;
  color: #333;
}
.contact-info {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease;
}
.contact-info:hover {
  border-color: #0380fe;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.2);
}
.contact-info h4 {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  color: #333;
}
.contact-info p {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
.contact-info strong {
  font-weight: bold;
}

.shipping-instructions-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.shipping-instructions-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.shipping-instructions-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
}
.delivery-section {
  margin-bottom: 24px;
}
.delivery-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
}
.delivery-card {
  flex: 1;
  min-width: 250px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  position: relative;
}
.delivery-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
  transform: translateY(-2px);
}
.delivery-icon {
  font-size: 28px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0380fe, #0056b3);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.3);
}
.delivery-info h5 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #333;
}
.delivery-info p {
  font-size: 14px;
  margin: 0 0 12px 0;
  color: #666;
  line-height: 1.5;
}
.time-badge {
  display: inline-block;
  background: #e8f4fd;
  color: #0380fe;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  border: 1px solid #0380fe;
}
.custom-delivery {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  margin: 16px 0;
}
.custom-delivery:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
}
.custom-icon {
  font-size: 28px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
}
.custom-info h5 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #333;
}
.custom-info p {
  font-size: 14px;
  margin: 0;
  color: #666;
  line-height: 1.5;
}
.shipping-method-info {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
}
.method-item {
  flex: 1;
  min-width: 250px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}
.method-item:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
}
.method-icon {
  font-size: 28px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}
.method-details h5 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #333;
}
.method-details p {
  font-size: 14px;
  margin: 0;
  color: #666;
  line-height: 1.5;
}
.delivery-tips {
  background: #e8f4fd;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  border-left: 4px solid #0380fe;
}
.delivery-tips h4 {
  color: #0380fe;
  margin-bottom: 12px;
}
.delivery-tips ul {
  padding-left: 20px;
}
.delivery-tips li {
  margin-bottom: 8px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
}

.after-sales-content .policy-table .table-container {
  overflow-x: auto;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.08);
  background: #fff;
}
.after-sales-content .policy-table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 800px;
  font-size: 14px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.after-sales-content .policy-table th,
.after-sales-content .policy-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}
.after-sales-content .policy-table th {
  background: #f5f8fa;
  color: #222;
  font-weight: bold;
  font-size: 15px;
}
.after-sales-content .policy-table tr:nth-child(even) {
  background: #f9fbfd;
}
.after-sales-content .policy-table tr:hover {
  background: #e8f4fd;
  transition: background 0.2s;
}
.after-sales-content .policy-table .status-yes {
  display: inline-block;
  background: #38d39f;
  color: #fff;
  border-radius: 12px;
  padding: 2px 12px;
  font-weight: bold;
  font-size: 13px;
}
.after-sales-content .policy-table .status-no {
  display: inline-block;
  background: #ff6b6b;
  color: #fff;
  border-radius: 12px;
  padding: 2px 12px;
  font-weight: bold;
  font-size: 13px;
}
.after-sales-content .policy-table .table-note {
  font-size: 13px;
  color: #888;
  margin: 8px 0 0 0;
  padding-left: 4px;
}

.contact-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.contact-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.contact-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
}
.contact-section {
  margin-bottom: 24px;
}
.contact-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
}
.contact-card {
  flex: 1;
  min-width: 250px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}
.contact-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
  transform: translateY(-2px);
}
.contact-icon {
  font-size: 28px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0380fe, #0056b3);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.3);
}
.contact-details h5 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #333;
}
.contact-info {
  font-size: 16px;
  font-weight: bold;
  color: #0380fe;
  margin: 0 0 4px 0;
}
.contact-desc {
  font-size: 12px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}
.company-info {
  margin: 16px 0;
}
.company-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.3s ease;
}
.company-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
}
.company-icon {
  font-size: 28px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  flex-shrink: 0;
}
.company-details h5 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 12px 0;
  color: #333;
}
.company-details ul {
  padding-left: 0;
  list-style: none;
}
.company-details li {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}
.company-details strong {
  color: #333;
}
.contact-tips {
  background: #e8f4fd;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  border-left: 4px solid #0380fe;
}
.contact-tips h4 {
  color: #0380fe;
  margin-bottom: 12px;
}
.contact-tips ul {
  padding-left: 20px;
}
.contact-tips li {
  margin-bottom: 8px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
}

.invoice-apply-content,
.invoice-search-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.invoice-apply-content h3,
.invoice-search-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.invoice-apply-content h4,
.invoice-search-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
  display: flex;
  align-items: center;
}
.invoice-step {
  background: white;
  padding: 20px;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.invoice-step .step-number {
  background: #0380fe;
}
.invoice-info {
  margin: 16px 0;
}
.invoice-card {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}
.invoice-card:hover {
  border-color: #0380fe;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.2);
}
.invoice-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0380fe, #0056b3);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(3, 128, 254, 0.3);
}
.invoice-details h5 {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #333;
}
.invoice-details ul {
  padding-left: 20px;
  margin: 0;
}
.invoice-details li {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 4px;
}
.invoice-tips {
  background: #e8f4fd;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  border-left: 4px solid #0380fe;
}
.invoice-tips h4 {
  color: #0380fe;
  margin-bottom: 12px;
}
.invoice-tips ul {
  padding-left: 20px;
}
.invoice-tips li {
  margin-bottom: 8px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
}

.platform-content {
  max-height: 600px;
  overflow-y: auto;
  background: #f9f9f9;
  padding: 24px 32px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.8;
  color: #222;
}
.platform-content h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #0380fe;
}
.platform-content h4 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 12px 0;
  color: #333;
}
.platform-section {
  margin-bottom: 24px;
}
.platform-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}
.platform-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
}
.platform-icon {
  font-size: 28px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0380fe, #0056b3);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(3, 128, 254, 0.3);
  flex-shrink: 0;
}
.platform-details h5 {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 12px 0;
  color: #333;
}
.platform-details p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}
.platform-advantages {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
}
.advantage-card {
  flex: 1;
  min-width: 250px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.3s ease;
}
.advantage-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
  transform: translateY(-2px);
}
.advantage-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
  flex-shrink: 0;
}
.advantage-details h5 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 12px 0;
  color: #333;
}
.advantage-details ul {
  padding-left: 20px;
  margin: 0;
}
.advantage-details li {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 6px;
}
.scene-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0;
}
.scene-card {
  flex: 1;
  min-width: 200px;
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  transition: all 0.3s ease;
}
.scene-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
  transform: translateY(-2px);
}
.quality-cards {
  margin: 16px 0;
}
.quality-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.3s ease;
}
.quality-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
}
.quality-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(255, 107, 53, 0.3);
  flex-shrink: 0;
}
.quality-details ul {
  padding-left: 20px;
  margin: 0;
}
.quality-details li {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 6px;
}
.case-cards {
  margin: 16px 0;
}
.case-card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.3s ease;
}
.case-card:hover {
  border-color: #0380fe;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.2);
}
.case-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6f42c1, #e83e8c);
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(111, 66, 193, 0.3);
  flex-shrink: 0;
}
.case-details ul {
  padding-left: 20px;
  margin: 0;
}
.case-details li {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 6px;
}
.brand-claim {
  text-align: center;
  margin: 24px 0;
}
.brand-quote {
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  color: #0380fe;
  padding: 16px 24px;
  background: linear-gradient(135deg, #e8f4fd, #f8fbff);
  border: 2px solid #0380fe;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(3, 128, 254, 0.1);
  position: relative;
}
.brand-quote::before {
  content: '"';
  font-size: 24px;
  color: #0380fe;
  position: absolute;
  top: -8px;
  left: 12px;
}
.brand-quote::after {
  content: '"';
  font-size: 24px;
  color: #0380fe;
  position: absolute;
  bottom: -8px;
  right: 12px;
}
</style>
